export default __webpack_public_path__ + "4afd9082db75b9235add2e78ba23fa9b.png";